import { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { LoginForm } from '../components/login-form';
import { MarcoDeIngreso, TarjetaDeIngreso, TituloDeIngreso } from '../components/marco-de-ingreso';
import { useRegistroPublico } from '../hooks/use-registro-publico';
import { useAuthStore } from '../store/auth-store';
import { destinoTrasIngresar } from '../destino-tras-ingresar';

export function LoginPage() {
  const registroAbierto = useRegistroPublico() === true;
  const navigate = useNavigate();
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const portales = useAuthStore((s) => s.portales);
  const refrescarPortales = useAuthStore((s) => s.refrescarPortales);

  /*
    Esta pantalla redirige sola cuando alguien YA autenticado vuelve a
    `/login` — no pasa por el formulario, así que la decisión tiene que estar
    también acá. La toma `destinoTrasIngresar`, la misma función que usa el
    formulario, para que no vuelvan a divergir.

    🔴 Y primero pide la lista si no la tiene. `portales` no se persiste, así
    que en una pestaña recién cargada está vacía — y eso **no** significa «no
    tiene empresas». Leerlo como tal es lo que mandaba a `/dashboard`, una ruta
    sin prefijo de empresa que el `basename` ya había invalidado. Acá sí se
    puede pedir: esta persona tiene sesión, que es lo que `/auth/portals`
    exige.
  */
  useEffect(() => {
    if (!isAuthenticated) return;
    let cancelado = false;

    (async () => {
      let lista = useAuthStore.getState().portales;
      if (lista.length === 0) {
        lista = await refrescarPortales()
          .then(() => useAuthStore.getState().portales)
          .catch(() => []);
      }
      if (cancelado) return;

      const destino = destinoTrasIngresar(lista);
      if (destino.tipo === 'elegir') {
        navigate('/portales', { replace: true });
      } else if (destino.tipo === 'entrar') {
        // Recarga completa: el `basename` se resuelve al montar el router.
        // Si la sesión que ya tiene es de otra empresa, el guardián de rutas
        // reconcilia contra la URL — no hace falta canjear acá.
        window.location.href = `/${destino.slug}/dashboard`;
      }
      // `sin-empresas`: se queda en el ingreso. No hay ninguna empresa a la
      // que mandarla, y `/dashboard` sólo la haría rebotar.
    })();

    return () => {
      cancelado = true;
    };
  }, [isAuthenticated, portales.length, navigate, refrescarPortales]);

  return (
    <MarcoDeIngreso>
      <TituloDeIngreso
        antes="Bienvenido a"
        marca="Prixia"
        subtitulo="Toda tu inteligencia de precios, en un solo lugar."
      />
      <TarjetaDeIngreso>
        <LoginForm />
      </TarjetaDeIngreso>
      {registroAbierto && (
        <p className="text-center text-sm text-muted-foreground">
          ¿No tienes cuenta?{' '}
          <Link to="/register" className="font-medium text-primary hover:underline">
            Registrarse gratis
          </Link>
        </p>
      )}
    </MarcoDeIngreso>
  );
}

export default LoginPage;
